var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 8.64,
    stroke: "#164387",
    strokeWidth: 0.72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0832 7.33366C10.0832 8.52858 9.11142 9.50033 7.9165 9.50033C6.72159 9.50033 5.74984 8.52858 5.74984 7.33366C5.74984 6.13874 6.72159 5.16699 7.9165 5.16699C9.11142 5.16699 10.0832 6.13874 10.0832 7.33366ZM10.8054 13.1114H10.4443C10.2449 13.1114 10.0832 12.9493 10.0832 12.7503V10.5837C10.0832 10.3847 10.2449 10.2225 10.4443 10.2225H10.8054C11.0051 10.2225 11.1665 10.0608 11.1665 9.86144C11.1665 9.6621 11.0051 9.50033 10.8054 9.50033H10.4443C9.847 9.50033 9.36095 9.98638 9.36095 10.5837V12.7503C9.36095 13.3476 9.847 13.8337 10.4443 13.8337H10.8054C11.0051 13.8337 11.1665 13.6719 11.1665 13.4725C11.1665 13.2732 11.0051 13.1114 10.8054 13.1114ZM13.1179 11.2174L12.321 10.5147C12.1726 10.3836 11.9433 10.397 11.8114 10.5468C11.6796 10.6963 11.6941 10.9245 11.8436 11.0564L12.1263 11.3059H11.1665C10.9668 11.3059 10.8054 11.4677 10.8054 11.667C10.8054 11.8663 10.9668 12.0281 11.1665 12.0281H12.1747L11.8436 12.3202C11.6941 12.452 11.6796 12.6803 11.8114 12.8298C11.9436 12.98 12.1722 12.9934 12.321 12.8619L13.1151 12.1617C13.2537 12.0422 13.3332 11.8696 13.3332 11.6883C13.3332 11.507 13.2537 11.3344 13.1179 11.2174ZM8.63873 10.5837C8.63873 10.4912 8.65245 10.402 8.66617 10.3132C8.42495 10.2561 8.17506 10.2225 7.9165 10.2225C6.12431 10.2225 4.6665 11.6807 4.6665 13.4725C4.6665 13.6719 4.82792 13.8337 5.02762 13.8337H9.00923C8.77992 13.531 8.63873 13.1584 8.63873 12.7503V10.5837Z",
    fill: "#164387"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.66667,
    height: 8.66667,
    fill: "white",
    transform: "translate(4.6665 5.16699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.d4b516e183e534ad15c1676087af5c35.svg";
export { ForwardRef as ReactComponent };